const displayName = 'ComponentPublic'

export default displayName